(function(){
  const API_URL = 'https://quote-gateway-dfe6a5o6.uc.gateway.dev/generate_quote';
  const API_KEY = 'AIzaSyB_9O23X9bFu39eOGvTDpY1ygx2oSTgH6Y';

  // 🔹 Helper function to get cart totals with tax & shipping
  async function getCartTotals(zip, country, state){
    try {
      // Update shipping address
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shipping_address: { zip, country, province: state }
        })
      });

      // Polling cart.js for tax
      let cart = null;
      const maxTries = 2;
      for(let i=0;i<maxTries;i++){
        await new Promise(r=>setTimeout(r,1000));
        const resp = await fetch('/cart.js');
        cart = await resp.json();
        if(cart.total_tax > 0) break;
      }

      if(!cart) cart = await (await fetch('/cart.js')).json();

      // Shipping rates
      let shipping = 0.0;
      try {
        const shipResp = await fetch(`/cart/shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${state}`);
        const shipData = await shipResp.json();
        if(shipData.shipping_rates && shipData.shipping_rates.length>0){
          shipping = parseFloat(shipData.shipping_rates[0].price);
          console.log('shiping is', shipping);
        }
      } catch(err){
        console.warn('Shipping fetch failed', err);
      }

      const subtotal = (cart.items_subtotal_price||0)/100.0;
      const tax = (cart.total_tax||0)/100.0;
      const total = subtotal + tax + shipping;

      return { subtotal, tax, shipping, total, cart };
    } catch(err){
      console.error('Error fetching cart totals:', err);
      return { subtotal:0, tax:0, shipping:0, total:0, cart:null };
    }
  }

  function openModal(initialCart){
    const modal = document.createElement('div');
    modal.id='quote-modal';
    modal.style='position:fixed;inset:0;background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;z-index:9999';
    modal.innerHTML = `
      <div style="background:#fff;padding:24px;max-width:600px;width:100%;border-radius:8px;box-shadow:0 2px 10px rgba(0,0,0,0.2)">
        <h3>Get Quote</h3>
        <p>Enter details to receive the PDF quote:</p>
        <input id="quote-name" type="text" placeholder="FULL NAME" style="width:100%;padding:8px;margin-bottom:8px" />
        <input id="quote-phone" type="tel" placeholder="CONTACT NUMBER" style="width:100%;padding:8px;margin-bottom:8px" />
        <input id="quote-address" type="text" placeholder="ADDRESS" style="width:100%;padding:8px;margin-bottom:8px" />
           <input id="quote-country"  value="US" type="text" placeholder="COUNTRY" style="width:100%;padding:8px;margin-bottom:8px" />
        <input id="quote-zip" type="text" placeholder="ZIP CODE" style="width:100%;padding:8px;margin-bottom:8px" />
        <input id="quote-state" type="text" placeholder="STATE/PROVINCE" style="width:100%;padding:8px;margin-bottom:8px" />
        <input id="quote-email" type="email" placeholder="EMAIL ADDRESS" style="width:100%;padding:8px;margin-bottom:8px" />
        <input id="quote-department" type="text" placeholder="DEPARTMENT / AGENCY" style="width:100%;padding:8px;margin-bottom:8px" />
        <div id="quote-message" style="margin-top:10px;font-size:14px;"></div>
        <div style="text-align:right;margin-top:12px">
          <button id="quote-cancel" style="margin-right:8px">Cancel</button>
          <button id="quote-send">Send Quote</button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);

    document.getElementById('quote-cancel').onclick = ()=> modal.remove();

    document.getElementById('quote-send').onclick = async ()=>{
      const btn = document.getElementById('quote-send');
      btn.disabled = true;
      btn.innerText = 'Sending… this can take up to 30 seconds';

      const name = document.getElementById('quote-name').value.trim();
      const phone = document.getElementById('quote-phone').value.trim();
      const address = document.getElementById('quote-address').value.trim();
      const zip = document.getElementById('quote-zip').value.trim();
      const country = document.getElementById('quote-country').value.trim().toUpperCase();
      const state = document.getElementById('quote-state').value.trim().toUpperCase();
      const email = document.getElementById('quote-email').value.trim();
      const department = document.getElementById('quote-department').value.trim();

      if(!email || !name || !phone || !zip || !country || !state){
        alert('Please fill all required fields (Name, Phone, ZIP, Country, State, Email)');
        btn.disabled=false;
        btn.innerText='Send Quote';
        return;
      }

      try {
        // 🔹 Get cart totals including tax & shipping
        const totalsData = await getCartTotals(zip, country, state);

        const payload = { 
          cart: totalsData.cart, 
          email, 
          customer: { name, phone, address, zip, country, state, email, department },
          totals: { subtotal: totalsData.subtotal, tax: totalsData.tax, shipping: totalsData.shipping, total: totalsData.total }
        };

        // Send to quote gateway
        const resp = await fetch(API_URL,{
          method:'POST',
          headers:{'Content-Type':'application/json','x-api-key':API_KEY},
          body:JSON.stringify(payload)
        });

        if(!resp.ok){
  const text = await resp.text();
  console.error("Backend returned error:", resp.status, text);
  $("#quote-message")
    .html("❌ Error sending quote: " + text)
    .css({
      "color": "#721c24",
      "background": "#f8d7da",
      "border": "1px solid #f5c6cb",
      "padding": "10px",
      "border-radius": "4px"
    });
  btn.disabled=false;
  btn.innerText='Send Quote';
  return;
}

$("#quote-message")
  .html("✅ Quote sent! Check your email.")
  .css({
    "color": "#155724",
    "background": "#d4edda",
    "border": "1px solid #c3e6cb",
    "padding": "10px",
    "border-radius": "4px"
  });
 btn.disabled = true;
    btn.style.opacity = 0.5; 
    btn.innerText = 'Send Quote';
  
    const cancelBtn = document.getElementById('quote-cancel');
  cancelBtn.innerText = 'OK';
  cancelBtn.onclick = () => modal.remove();
// modal.remove();
      } catch(err){
        console.error("Error sending quote:", err);
$("#quote-message")
  .html("❌ Something went wrong sending your quote. Please try again, or email sales@tacstix.com.")
  .css({
    "color": "#721c24",
    "background": "#f8d7da",
    "border": "1px solid #f5c6cb",
    "padding": "10px",
    "border-radius": "4px"
  });
 btn.disabled = false;
     btn.style.opacity = 1;
    btn.innerText = 'Send Quote';
   
  const cancelBtn = document.getElementById('quote-cancel');
 cancelBtn.innerText = 'OK';
 cancelBtn.onclick = () => modal.remove();
      }
    }
  }
  document.addEventListener('DOMContentLoaded', function(){
    const buttons = document.querySelectorAll('.generate-quote-btn');
    buttons.forEach(btn=>{
      btn.addEventListener('click', async function(){
        const cartResp = await fetch('/cart.js');
        const cart = await cartResp.json();
        openModal(cart);
      });
    });
  });
})();